import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { USER_ROLES } from "../constants/appConstants";
import { getUserRole } from "../services/userRoleService";

const allowed = new Set([USER_ROLES.ADMIN, USER_ROLES.SUPER_ADMIN]);

export default function AdminRoute({ children }) {
  const { user, authLoading } = useAuth();
  const [checkingRole, setCheckingRole] = useState(true);
  const [role, setRole] = useState(USER_ROLES.VIEWER);

  useEffect(() => {
    let active = true;
    async function run() {
      if (!user) {
        setRole(USER_ROLES.VIEWER);
        setCheckingRole(false);
        return;
      }
      try {
        const r = await getUserRole(user.uid);
        if (active) setRole(r || USER_ROLES.VIEWER);
      } finally {
        if (active) setCheckingRole(false);
      }
    }
    setCheckingRole(true);
    run();
    return () => {
      active = false;
    };
  }, [user]);

  if (authLoading || checkingRole) {
    return <div className="p-6">Checking admin access...</div>;
  }

  if (!user) return <Navigate to="/login" />;
  if (!allowed.has(role)) return <Navigate to="/dashboard" />;
  return children;
}

